import AnnotationController from '../annotation/controller';
import {FeatureNameEnum} from './helper';

class FeatureManager {
    constructor() {

    }

    updateSeeThrough(featureName, isSeeThroughEnabled) {
        switch (featureName) {
            case FeatureNameEnum.MEASUREMENT:
                measurementController.serverMessageHandler.setSeeThrough(isSeeThroughEnabled);
                break;
            case FeatureNameEnum.ANNOTATION:
                AnnotationController.serverMessageHandler.setSeeThrough(isSeeThroughEnabled);
                break;
            case FeatureNameEnum.INFORMATION_ANNOTATION:
                informationAnnotationFeature.updateSeeThrough(isSeeThroughEnabled);
                break;
            case FeatureNameEnum.MEDIA_SCREEN:
                MediaScreenManager.changeMediaPlaneSeeThrough(isSeeThroughEnabled);
                break;
            default:
                return;
        }
    }
}


export default FeatureManager;